import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Header from "../../components/Header"
import { gradientLightPink } from "../../ds/gradients.module.css"
import { Helmet } from "react-helmet"

// List of reports - will grow over time
const reports = [
  {
    title: "Attendee-Generated Content Impact Report",
    description: "Discover key insights on how attendee-generated content drives event success based on our 2025 survey results of event marketing professionals.",
    path: "/reports/attendee-generated-content-impact-report-2025/",
    date: "June 2025",
    thumbnailBg: "#7251f4",
    tags: ["Content Marketing", "UGC", "Event ROI"]
  }
]

const ReportsIndex = () => {
  return (
    <Layout
      title="Event Marketing Reports & Research | Premagic"
      description="Access our collection of free reports, studies, and research on event marketing trends, technology, and best practices."
      meta={[
        { name: "keywords", content: "event marketing reports, event industry research, marketing studies, event trends, event technology" },
        { name: "og:title", content: "Event Marketing Reports & Research | Premagic" },
        { name: "og:description", content: "Access our collection of free reports, studies, and research on event marketing trends, technology, and best practices." },
      ]}
    >
      <Helmet>
        <style>{`
          .report-card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            overflow: hidden;
          }
          
          .report-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
          }
          
          .report-thumbnail {
            height: 160px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: 600;
            position: relative;
            overflow: hidden;
          }
          
          .report-thumbnail::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(135deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.4) 100%);
          }
          
          .tag {
            font-size: 11px;
            padding: 4px 10px;
            border-radius: 20px;
            background: #f1f4ff;
            color: #1F0F61;
            margin-right: 6px;
            margin-bottom: 6px;
            display: inline-block;
          }
          
          .report-date {
            font-size: 12px;
            color: #666;
            margin-bottom: 8px;
          }
          
        `}</style>
      </Helmet>

      <div className={gradientLightPink}>
        <Header />
        <div className="pm-container py-10 md:py-14">
          <h1 className="font-bold text-2xl md:text-4xl text-center" style={{ color: 'var(--color-blue-dark, #1F0F61)' }}>
            Event Marketing Reports & Research
          </h1>
          <p className="text-gray-600 mt-2 text-center max-w-2xl mx-auto">
            Access our latest insights, research, and trend reports to stay ahead in event marketing.
            All reports are free with email registration.
          </p>
        </div>
      </div>

      <div className="pm-container py-12">
        {/* Reports grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reports.map((report, index) => (
            <Link 
              to={report.path} 
              key={index}
              className="report-card rounded-lg overflow-hidden border border-gray-100 hover:no-underline"
            >
              <div 
                className="report-thumbnail" 
                style={{ backgroundColor: report.thumbnailBg }}
              >
                <span className="relative z-10 text-center px-4">{report.title}</span>
              </div>
              <div className="p-5">
                <div className="report-date">{report.date}</div>
                <p className="text-gray-700 mb-3">{report.description}</p>
                <div>
                  {report.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="tag">{tag}</span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </Layout>
  )
}

export default ReportsIndex